
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M9.197 14.41l-.793.693a.942.942 0 01-1.211 0L.25 9.031a.683.683 0 010-1.06l6.943-6.074a.942.942 0 011.21 0l.794.694a.687.687 0 01-.015 1.072L4.88 7.25h10.264c.475 0 .857.334.857.75v1c0 .416-.382.75-.857.75H4.879l4.303 3.588c.35.29.357.775.015 1.071z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    